import type { Cart, Order, CustomLineItem, LineItem } from '~~/types/commercetools';

const centAmountToNormalPrice = (centAmount: number | undefined | null): number | null => (
  centAmount === null || centAmount === undefined
    ? null
    : Number((centAmount / 100).toFixed(2))
);

const getTotalGrossPrice = (cartOrOrder: Cart | Order | CustomLineItem | LineItem): number | null => {

  return centAmountToNormalPrice(cartOrOrder?.taxedPrice?.totalGross?.centAmount);

};

const getTotalCentAmount = (totalGrossPrice: number): number => {

  return Number((totalGrossPrice * 100).toFixed());

};

export { centAmountToNormalPrice, getTotalGrossPrice, getTotalCentAmount };
